import { render, staticRenderFns } from "./message-content-panel.vue?vue&type=template&id=5b225b38"
import script from "./message-content-panel.vue?vue&type=script&lang=js"
export * from "./message-content-panel.vue?vue&type=script&lang=js"
import style0 from "./message-content-panel.vue?vue&type=style&index=0&id=5b225b38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports